module.exports = __webpack_public_path__ + "img/8.d91fb0ba.svg";